<template>
  <el-dialog
    title="付款凭证"
    :visible.sync="formVisible"
    :close-on-click-modal="false"
    width="800px"
  >
    <div class="voucher-content">
      <div class="total-amount" v-if="currentRow">
        报名总金额{{ currentRow.fee || 0 }}元
      </div>

      <div class="voucher-list" v-if="voucherList && voucherList.length > 0">
        <div
          class="voucher-item"
          v-for="(item, index) in voucherList"
          :key="index"
        >
          <div class="voucher-image">
            <el-image
              :src="item.payImg || item"
              :preview-src-list="previewImageList"
              fit="cover"
            ></el-image>
          </div>
          <div class="voucher-details">
            <div class="detail-row">
              <span class="label">收款银行：</span>
              <span class="value">{{ item.payBank || "-" }}</span>
              <span class="label" style="margin-left: 20px;">支付单号：</span>
              <span class="value">{{ item.payNum || "-" }}</span>
            </div>
            <div class="detail-row">
              <span class="label">付款金额：</span>
              <span class="value">{{ item.payMoney || "-" }}</span>
              <span class="label" style="margin-left: 20px;">付款日期：</span>
              <span class="value">{{ item.payTime || "-" }}</span>
            </div>
            <div class="detail-row">
              <el-button
                type="primary"
                size="small"
                @click="handleCopyVoucher(item, index)"
              >
                复制凭证
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-voucher">
        暂无付款凭证
      </div>

      <div class="account-entry" v-if="accountEntryInfo">
        入账进入：{{ accountEntryInfo }}
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import meetingSignUpApi from "@/api/meeting/meetingSignUp";

export default {
  data() {
    return {
      formVisible: false,
      currentRow: null,
      voucherList: [],
      accountEntryInfo: ""
    };
  },
  computed: {
    previewImageList() {
      return this.voucherList.map(item => item.payImg || item).filter(Boolean);
    }
  },
  watch: {
    formVisible(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  methods: {
    /**
     * 打开弹窗
     */
    handleCreate(row) {
      this.currentRow = row;
      this.formVisible = true;
      this.initVoucherData(row);
      // 调用接口获取入账金额明细
      if (row.id) {
        this.loadAccountEntryInfo(row.id);
      }
    },
    /**
     * 加载入账金额明细
     */
    loadAccountEntryInfo(id) {
      meetingSignUpApi
        .giftAmountDetailEstimate(id)
        .then(res => {
          if (res && res.data) {
            const data = res.data;
            const typeMap = {
              1: "余额",
              2: "零售价",
              3: "学费"
            };

            // 优先使用 giftAccountType 和 giftAccountAmount
            if (
              data.giftAccountType !== undefined &&
              data.giftAccountAmount !== undefined
            ) {
              const typeName = typeMap[data.giftAccountType] || "未知";
              this.accountEntryInfo = `${data.giftAccountAmount}${typeName}`;
              return;
            }

            // 其次使用 amount 字段（需要配合 giftAccountType）
            if (
              data.giftAccountType !== undefined &&
              data.amount !== undefined
            ) {
              const typeName = typeMap[data.giftAccountType] || "未知";
              this.accountEntryInfo = `${data.amount}${typeName}`;
              return;
            }

            // 如果返回的是 giftAccounts 对象，需要解析
            if (data.giftAccounts && typeof data.giftAccounts === "object") {
              const keys = Object.keys(data.giftAccounts);
              if (keys.length > 0) {
                // 取第一个有值的类型和金额
                const firstKey = keys.find(key => data.giftAccounts[key]);
                if (firstKey) {
                  const typeName = typeMap[parseInt(firstKey)] || "未知";
                  this.accountEntryInfo = `${
                    data.giftAccounts[firstKey]
                  }${typeName}`;
                  return;
                }
              }
            }

            // 如果都没有，尝试使用行数据中的信息
            this.setAccountEntryInfo(this.currentRow);
          } else {
            // 如果接口返回数据为空，使用行数据中的信息
            this.setAccountEntryInfo(this.currentRow);
          }
        })
        .catch(error => {
          console.error("获取入账金额明细失败:", error);
          // 如果接口失败，使用行数据中的信息
          this.setAccountEntryInfo(this.currentRow);
        });
    },
    /**
     * 初始化付款凭证数据
     */
    initVoucherData(row) {
      // 优先使用 payVouchersList
      if (row.payVouchersList && row.payVouchersList.length > 0) {
        this.voucherList = row.payVouchersList;
      } else if (row.payVoucherList && row.payVoucherList.length > 0) {
        this.voucherList = row.payVoucherList;
      } else if (row.payVouchers && row.payVouchers.length > 0) {
        // 如果是字符串数组，转换为对象数组
        this.voucherList = row.payVouchers.map(img => ({ payImg: img }));
      } else {
        this.voucherList = [];
      }

      // 设置入账进入信息
      this.setAccountEntryInfo(row);
    },
    /**
     * 设置入账进入信息
     */
    setAccountEntryInfo(row) {
      // 根据入账金额类型和金额生成信息
      if (row.giftAccountType && row.giftAccountAmount) {
        const typeMap = {
          1: "余额",
          2: "零售价",
          3: "学费"
        };
        const typeName = typeMap[row.giftAccountType] || "未知";
        this.accountEntryInfo = `${row.giftAccountAmount}${typeName}`;
      } else if (row.giftAccounts && typeof row.giftAccounts === "object") {
        // 如果是从 giftAccounts 对象中获取
        const entries = Object.entries(row.giftAccounts).filter(
          ([key, value]) => value
        );
        if (entries.length > 0) {
          const [type, amount] = entries[0];
          const typeMap = {
            1: "余额",
            2: "零售价",
            3: "学费"
          };
          const typeName = typeMap[parseInt(type)] || "未知";
          this.accountEntryInfo = `${amount}${typeName}`;
        }
      } else {
        this.accountEntryInfo = "";
      }
    },
    /**
     * 复制凭证
     */
    handleCopyVoucher(item, index) {
      // 复制当前凭证信息到剪贴板或执行其他操作
      const voucherInfo = `收款银行：${item.payBank ||
        "-"}\n支付单号：${item.payNum || "-"}\n付款金额：${item.payMoney ||
        "-"}\n付款日期：${item.payTime || "-"}`;

      // 创建临时文本区域来复制文本
      const textarea = document.createElement("textarea");
      textarea.value = voucherInfo;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("凭证信息已复制到剪贴板");
      } catch (err) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(textarea);
    },
    /**
     * 重置
     */
    reset() {
      this.currentRow = null;
      this.voucherList = [];
      this.accountEntryInfo = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.voucher-content {
  .total-amount {
    font-size: 16px;
    color: #000000;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .voucher-list {
    .voucher-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 30px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }

      .voucher-image {
        margin-right: 20px;
        flex-shrink: 0;
        width: 120px;
        height: 160px;
        overflow: hidden;
        border: 1px solid #eee;
        border-radius: 4px;

        ::v-deep .el-image {
          width: 100%;
          height: 100%;
        }
      }

      .voucher-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-top: 0;

        .detail-row {
          margin-bottom: 12px;
          line-height: 1.6;
          font-size: 13px;

          &:last-child {
            margin-bottom: 0;
            margin-top: 8px;
          }

          .label {
            color: #8f8e8e;
            margin-right: 8px;
          }

          .value {
            color: #8f8e8e;
          }
        }
      }
    }
  }

  .no-voucher {
    text-align: center;
    color: #999;
    padding: 40px 0;
    font-size: 14px;
  }

  .account-entry {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    font-size: 14px;
    color: #333;
  }
}
</style>
